import { $, show, hide } from './utils.js';
import { AllStats, FeedbackEntry } from '../shared/events.js';

export function switchAdminTab(tab: string): void {
  document.querySelectorAll('.admin-tab').forEach(b => {
    b.classList.toggle('active', (b as HTMLElement).dataset.tab === tab);
  });
  document.querySelectorAll('.admin-tab-panel').forEach(p => p.classList.add('hidden'));
  const panel = document.getElementById(`admin-tab-${tab}`);
  if (panel) panel.classList.remove('hidden');
}

export function openAdminStats(socket: any): void {
  socket.emit('admin:getStats', (response: AllStats | { error: string }) => {
    if ('error' in response) { alert(response.error); return; }
    renderAdminStats(response);
    switchAdminTab('stats');
    show($('#admin-stats-modal'));
  });
}

export function renderAdminStats(stats: AllStats): void {
  const totalsEl = $('#admin-stats-totals');
  totalsEl.innerHTML = `
    <div class="admin-stats-row">
      <div class="admin-stat-box"><span class="admin-stat-num">${stats.totalUsers}</span><span class="admin-stat-label">Total Users</span></div>
      <div class="admin-stat-box"><span class="admin-stat-num">${stats.totalGamesPlayed}</span><span class="admin-stat-label">Games Completed</span></div>
      <div class="admin-stat-box"><span class="admin-stat-num">${stats.totalTimesPlayed}</span><span class="admin-stat-label">Times Played</span></div>
    </div>
  `;

  const tbody = $('#admin-stats-body') as HTMLTableSectionElement;
  tbody.innerHTML = '';

  if (stats.users.length === 0) {
    const tr = document.createElement('tr');
    tr.innerHTML = '<td colspan="5" style="text-align:center;color:rgba(255,255,255,0.4);padding:16px">No players yet.</td>';
    tbody.appendChild(tr);
    return;
  }

  const sorted = [...stats.users].sort((a, b) => b.gamesPlayed - a.gamesPlayed);
  for (const user of sorted) {
    const winPct = user.gamesPlayed > 0
      ? Math.round((user.wins / user.gamesPlayed) * 100)
      : 0;
    const adminBadge = user.name === 'admin' ? ' <span class="admin-badge">ADMIN</span>' : '';
    const tr = document.createElement('tr');
    tr.innerHTML = `
      <td>${escapeHtml(user.name)}${adminBadge}</td>
      <td class="admin-num">${user.gamesPlayed}</td>
      <td class="admin-num admin-win">${user.wins}</td>
      <td class="admin-num admin-loss">${user.losses}</td>
      <td class="admin-num">${winPct}%</td>
    `;
    tbody.appendChild(tr);
  }
}

export function escapeHtml(text: string): string {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

export function renderFeedback(entries: FeedbackEntry[]): void {
  const tbody = document.getElementById('admin-feedback-body') as HTMLTableSectionElement;
  if (!tbody) return;
  tbody.innerHTML = '';

  if (entries.length === 0) {
    const tr = document.createElement('tr');
    tr.innerHTML = '<td colspan="4" style="text-align:center;color:#888;padding:16px">No feedback yet.</td>';
    tbody.appendChild(tr);
    return;
  }

  const sorted = [...entries].reverse();
  for (const entry of sorted) {
    const date = new Date(entry.timestamp).toLocaleString();
    const typeLabel = entry.type === 'bug' ? '🐛 Bug' : '💡 Suggest';
    const tr = document.createElement('tr');
    tr.innerHTML = `
      <td style="white-space:nowrap;font-size:12px">${escapeHtml(date)}</td>
      <td>${escapeHtml(entry.playerName)}</td>
      <td>${typeLabel}</td>
      <td style="word-break:break-word">${escapeHtml(entry.text)}</td>
    `;
    tbody.appendChild(tr);
  }
}
